module.exports = __webpack_public_path__ + "img/4.4189d5b8.jpg";